import { useTranslation } from 'react-i18next';
import { classicUrl } from '@/utils/classicLinks';
import { useAccountNavigationItems } from './subNavigation/useAccountNavigationItems';

export const useAccountNavigationItem = () => {
  const { t } = useTranslation('navigation');

  return {
    id: 'account',
    icon: 'Profile' as const,
    path: classicUrl('personalisation/my-default-team'),
    label: t('crossPlatform.primary.account'),
    subNav: useAccountNavigationItems(),
  };
};
